module.exports = __webpack_public_path__ + "static/media/AmazonResponseReceived.eb7a6931.svg";